module.exports = __webpack_public_path__ + "img/38650-022.52da813a.jpg";